module.exports = __webpack_public_path__ + "img/icono_arts_language.e239c6aa.svg";